<template>
    <div class="calendar-bottom">
        <div>
            <calendar-hours :hoursData="calendarHours" @setHoursData="setHours" :current="currentHours"></calendar-hours>
            <span class="calendar-fg">:</span>
            <calendar-hours :hoursData="calendarMints" @setHoursData="setMints" :current="currentMints"></calendar-hours>
        </div>
        <div>
            <div class="calendar-cancel" @click="cancelClick">{{ $t("zhiji.common.cancel") }}</div>
            <div class="calendar-btn" @click="confirmClick">{{ $t("zhiji.common.confirm") }}</div>
        </div>
    </div>
</template>

<script>
import { padStartZero } from "@/views/zhiji/js/common/util.js";

import CalendarHours from "./CalendarHours";

export default {
    name: "CalendarBottom",
    props: ["hour", "min"],
    data() {
        return {
            currentHours: this.hour || "00",
            currentMints: this.min || "00",
            calendarHours: getHoursAndMints(24),
            calendarMints: getHoursAndMints(60)
        };
    },
    components: {
        CalendarHours
    },
    methods: {
        setHours(data) {
            this.currentHours = data;
        },
        setMints(data) {
            this.currentMints = data;
        },
        cancelClick() {
            this.$emit("cancel");
        },
        confirmClick() {
            let setTimes = this.currentHours + ":" + this.currentMints;
            this.$emit("confirm", setTimes);
        }
    }
};

function getHoursAndMints(num) {
    let hours = new Array(num).fill([]).map((item, index) => {
        return padStartZero(index, 2);
    });

    return hours;
}
</script>

<style lang="less" scoped>
.calendar-bottom {
    padding: 8px 0px 8px 8px;
    background: #f2f7fb;
    display: flex;
    box-sizing: border-box;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    > div {
        font-size: 0;
    }
}
.calendar-cancel,
.calendar-btn {
    display: inline-block;
    margin-right: 8px;
    padding: 3px 13px;
    font-size: 12px;
    box-sizing: border-box;
    border: solid 1px #d8e4f0;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
}
.calendar-cancel {
    background: #fff;
    &:hover {
        color: #2ec2ff;
    }
}
.calendar-btn {
    background: #2ec2ff;
    color: #fff;
    border-color: #2ec2ff;
    &:hover {
        background: rgba(46, 194, 255, 0.8);
    }
}
.calendar-fg {
    font-size: 14px;
    vertical-align: text-bottom;
    margin: 0 3px 0 -5px;
}
</style>
